import { GL_BYTE, GL_INT, GL_SHORT, GL_UNSIGNED_BYTE, GL_UNSIGNED_INT, GL_UNSIGNED_SHORT } from "../shader/buffer";
export function toDataType(size, glType) {
    switch (size) {
        case 2:
            return "vec2";
        case 3:
            return "vec3";
        case 4:
            return "vec4";
        case 9:
            return "mat3";
        case 16:
            return "mat4";
    }
    let type = "float";
    if (glType === GL_INT || glType === GL_SHORT || glType === GL_BYTE)
        type = "int";
    else if (glType === GL_UNSIGNED_INT || glType === GL_UNSIGNED_SHORT || glType === GL_UNSIGNED_BYTE)
        type = "uint";
    return size === 1 ? type : `${type}[${size}]`;
}
export const GLSL_ARG = {
    tex: "_texSampler",
    st: "_st",
    color0: "_c0",
    color1: "_c1",
};
export const isMesh = "IS_MESH"; // a define to check if the shader is compiled for a mesh
export const GLSL_TYPE_LOOKUP = {
    src: { returnType: "vec4", args: [`vec3 ${GLSL_ARG.st}`] },
    coord: { returnType: "vec3", args: [`vec3 ${GLSL_ARG.st}`] },
    color: { returnType: "vec4", args: [`vec4 ${GLSL_ARG.color0}`] },
    combine: { returnType: "vec4", args: [`vec4 ${GLSL_ARG.color0}`, `vec4 ${GLSL_ARG.color1}`] },
    combineCoord: { returnType: "vec3", args: [`vec3 ${GLSL_ARG.st}`, `vec4 ${GLSL_ARG.color0}`] },
    value: { returnType: "float", args: [`vec3 ${GLSL_ARG.st}`] },
};
